module.exports = "<div class=\"loader-wrapper\" [ngClass]=\"{inverted: inverted}\">\n  <img class=\"loading-img\" [src]=\"currentPath\">\n</div>"